import { render, staticRenderFns } from "./ContentGameHistoryDesktop.vue?vue&type=template&id=11524a22&scoped=true&"
import script from "./ContentGameHistoryDesktop.vue?vue&type=script&lang=js&"
export * from "./ContentGameHistoryDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContentGameHistoryDesktop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContentGameHistoryDesktop.vue?vue&type=style&index=1&id=11524a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11524a22",
  null
  
)

export default component.exports